export const setCartDetails = (cartDetails) => localStorage.setItem('cartDetails', cartDetails);
export const getCartDetails = () => localStorage.getItem('cartDetails');

export const setCartMessageResponse = (cartResponse) => localStorage.setItem('cartResponse', cartResponse);
export const getCartMessageResponse = () => localStorage.getItem('cartResponse');
export const deleteCartDetails = () => localStorage.setItem('cartDetails', undefined);

export const setShoppingCartDetails = (shoppingCartDetails) => localStorage.setItem('shoppingCartDetails', shoppingCartDetails);
export const getShoppingCartDetails = () => localStorage.getItem('shoppingCartDetails');
export const deleteShoppingCartDetails = () => localStorage.setItem('shoppingCartDetails', undefined);
